import { render, staticRenderFns } from "./SchoolEstablishmentsIndex.vue?vue&type=template&id=23029b23"
import script from "./SchoolEstablishmentsIndex.vue?vue&type=script&lang=js"
export * from "./SchoolEstablishmentsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports